"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._constructPlainDate = void 0;
var js_temporal_polyfill_1 = require("@mishakanai/js-temporal-polyfill");
var F_PlainDate_1 = __importDefault(require("./F_PlainDate"));
var util_1 = require("./util");
/** @hidden */
var _constructPlainDate = function (arg1, arg2, arg3) {
    var plainDate = (0, util_1._constructTemporalPlainDate)(arg1, arg2, arg3);
    return new F_PlainDate_1.default(plainDate);
};
exports._constructPlainDate = _constructPlainDate;
var PlainDateBuilder = /** @class */ (function () {
    /** @hidden */
    function PlainDateBuilder() {
        throw new Error("don't");
    }
    PlainDateBuilder.of = function (arg1, arg2, arg3) {
        return (0, exports._constructPlainDate)(arg1, arg2, arg3);
    };
    PlainDateBuilder.today = function () {
        var plainDateToday = js_temporal_polyfill_1.Temporal.Now.plainDateISO();
        return new F_PlainDate_1.default(plainDateToday);
    };
    return PlainDateBuilder;
}());
exports.default = PlainDateBuilder;
//# sourceMappingURL=PlainDateBuilder.js.map